import { Field, Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid, currentTenant, ccountry, gstin } from '../../Common/Credentials.js';
import Footer from '../../Component/Footer.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import WarehouseServices from './WarehouseServices.js';
import { Spinner } from 'react-bootstrap';
import MasterService from '../MasterService.js';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';
import TextfieldComponent from '../../Component/TextfieldComponent.jsx';
import AutoCompeteField from '../../NewUI/NewComponents/AutoCompeteField.jsx';


class NewWarehouse extends Component {
  constructor(props) {
    super(props)
    console.log(this.props)
    this.state = {
      pagename:this.props.location.state.pagename,
      id:this.props===undefined||this.props.location.state===undefined||this.props.location.state.id===undefined?'':this.props.location.state.id,
      name: '',
      address:'',
      loader:false,
      gstin:gstin,
      CountryData: [],
      StateData: [],
      CityData: [],
      country:null,
      state:null,
      city:null,
      zip:""
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit(values) {
     this.setState({loader:true})
    if(this.state.pagename==='New Org Unit'){
      let addwarehouse = { 
        name:values.name,
        address:values.address,

        tenantid: currentTenant
      }
    WarehouseServices.addwarehouse(addwarehouse).then(() => 
    this.props.navigate('/warehouse'))
    .catch((e)=>{
      if(e.response.data.error ==="Unauthorized"){
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
      }
  })
  }else{
    let addwarehouse = { 
      id:values.id,
      name:values.name,
      address:values.address,
      tenantid: currentTenant
    }
  WarehouseServices.EditWarehouse(addwarehouse).then(() => 
    this.props.navigate('/warehouse'))
    .catch((e)=>{
      if(e.response.data.error ==="Unauthorized"){
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
      }
  })
  }
  }

  componentDidMount() {

    if(userid===undefined){
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }
    this.setState({gstin:gstin})

    if(this.props.location.state.id!==-1){
      WarehouseServices.getWarehouse(this.props.location.state.id).then(res=>{
        this.setState({name:res.data.name,address:res.data.address})
      })
    }
    MasterService.getCountries().then((response) =>
      this.setState({
        CountryData: response.data,
      }))
 }

 ChangeCountry = (value, values) => {
  if(values!=='' && typeof values === 'object' && values!==null){
  this.setState({country:values.name, CountryId: values.id,phonecode:values.phonecode,state :'', StateId: '',city:'',CityId:'',CityData:[] });
  MasterService.getStates(values.id).then((response) => {
    this.setState({
      StateData: response.data,
    });
  });
}else{
  this.setState({
    country:'', CountryId:'', state :'',StateData:[],CityData:[], StateId: '',city:'',CityId:''
  })
}
};
ChangeState = (value, values) => {
  if(values!=='' && typeof values === 'object' && values !== null){
  this.setState({state:values.name, StateId: values.id,statecode:values.code });
  MasterService.getCities(values.id).then((response) => {
    this.setState({
      CityData: response.data,city:'',CityId:''
    });
  });
 }else{
   this.setState({
  state:'', StateId: '',city:'',CityId:''
   })
 }
};

handleCity=(value,values)=>{
  if(values!=='' && typeof values === 'object' && values !== null){
  this.setState({city: values.name,CityId: values.id})
}else{
  this.setState({city:'',CityId:''})
}
}


  validate(values) {

    let errors = {}

     if (!values.name|| values.name==='') {
     errors.name = "Org Unit Name is Required";
      }
    if (!values.address || values.address === '') {
      errors.address = 'Org Unit Address is Required';
    }
    return errors;
  }

  render() {
     let {id,name,address} = this.state;
 
    return (
      
      <div>
      <Header />
         <Menu/>
        <div className="content-wrapper">
        <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/masters"},{name:"Organization Units",path:"/warehouse"},{name:"New Organization Unit",path:null}]}/>
          </div>
            <div className="UI-form-card">
              <Formik
                initialValues={{id,name,address}}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}>
                {({errors}) => (
                  <Form autoComplete="off">
                    <div className="form-row">
                      <fieldset hidden className=" col-md-6">
                        <label>Id</label>
                        <Field className="form-control" type="text" name="id" placeholder="Id"/>
                      </fieldset>

                      <fieldset className=" col-md-4">
                      <TextfieldComponent type="text" name="name" label="Org Unit Name" onChange={(e)=>this.setState({name:e.target.value})} error={errors?.name} required/>
                      </fieldset>
                      <fieldset className=" col-md-4">
                      <TextfieldComponent type="text" name="address" label="Org Unit Address" onChange={(e)=>this.setState({address:e.target.value})} error={errors?.address} required/>
                      </fieldset>

                      {/* <fieldset className=" col-md-4">
                        <FormikTextField
                          className="form-control"
                          type="text"
                          name="address2"
                          label="Area/Place"
                          value={this.state.address2}
                          onChange={(e) =>
                            this.setState({ address2: e.target.value })
                          }
                        />
                      </fieldset> */}

                      <fieldset className=" col-md-4 m-0">
                      <AutoCompeteField id="country" name="country" options={this.state.CountryData} label="Select Country" value={this.state.country} labelKey={"name"} valueKey={"name"} onChange={this.ChangeCountry} error={errors?.country} required/>
                      </fieldset>

                      <fieldset className=" col-md-4">
                      <AutoCompeteField id="state" name="state" options={this.state.StateData} label="Select State" value={this.state.state} labelKey={"name"} valueKey={"name"} onChange={this.ChangeState} error={errors?.state} required/>
                      </fieldset>

                      <fieldset className=" col-md-4">
                      <AutoCompeteField id="city" name="city" options={this.state.CityData} label="Select City" value={this.state.city} labelKey={"name"} valueKey={"name"} onChange={this.handleCity} error={errors?.city} required/>
                      </fieldset>
                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="zip" label={this.state.country==="India"?"Zip/Pincode":"PO BOX No."} value={this.state.zip} onChange={(e) =>this.setState({ zip: e.target.value })} error={errors?.zip} required/>
                      </fieldset>
                      {ccountry==="India" && 
                      <fieldset className=" col-md-4">
                      <TextfieldComponent className="form-control"  type="text" name="gstin" label="GSTIN" value={this.state.gstin} onChange={(e)=>this.setState({gstin:e.target.value})} error={errors?.gstin} required/>
                      </fieldset>
                        }
                    </div>
                    <div className=" col-md-12 tw-flex tw-justify-end">
                    {this.state.loader===true?  <button className="UI-btn UI-btn-primary tw-mr-1" disabled><Spinner animation="border" size="sm" />&nbsp;{"Saving"}</button>: <button className="UI-btn UI-btn-primary tw-mr-1" type="submit">Save</button>}
                    <Link as="button" className="UI-btn UI-btn-outline" to={{pathname: '/warehouse'}} >Cancel </Link> 
                    </div>
                  
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

      <Footer/>
      </div>
    );
  }
}
export default withRouter(NewWarehouse)